// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.booking-status-page {
  width: 100%;
  max-width: 1680px;
  margin: auto;
  padding: 1.5rem 2rem 3rem;
}

.heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin: 1.5rem 0 1rem;
}
.heading h1 {
  font-size: 1.5rem;
  margin: 0 0 0.4rem;
}
.heading p {
  margin: 0;
  color: var(--tj-primary-gray-500);
}

.schedule-note {
  background: var(--tj-primary-gray-50);
  padding: 0.9rem 1rem;
  border-radius: 0.5rem;
}
.schedule-note i {
  margin-right: 0.5rem;
}

.panel {
  background: var(--p-surface-0);
  border: 1px solid var(--tj-primary-gray-200);
  border-radius: 0.6rem;
  overflow: hidden;
}

.toolbar {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
}
.toolbar span {
  margin-left: auto;
  color: var(--tj-primary-gray-500);
}

label {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.9rem;
  font-weight: 600;
}

select, textarea {
  border: 1px solid var(--tj-primary-gray-300);
  border-radius: 0.4rem;
  color: inherit;
  background: var(--p-surface-0);
  padding: 0.65rem;
  font: inherit;
}

.check {
  flex-direction: row;
  align-items: center;
  font-weight: 400;
  min-height: 2.5rem;
}

.definition {
  margin: 0.4rem 0 0;
  max-width: 32rem;
  color: var(--tj-primary-gray-500);
  font-size: 0.85rem;
  white-space: normal;
}

.observations {
  font-size: 0.8rem;
}
.observations span {
  display: block;
  white-space: nowrap;
  margin-bottom: 0.3rem;
}

.actions button {
  margin-right: 0.6rem;
  margin-bottom: 0.4rem;
}

button.text-button, .actions button, .error button {
  border: 0;
  padding: 0.5rem;
  border-radius: 0.3rem;
  background: transparent;
  color: var(--tj-primary-600);
  font: inherit;
  cursor: pointer;
}

.actions .delete {
  color: var(--p-red-700);
}

.badge {
  padding: 0.3rem 0.5rem;
  border-radius: 0.3rem;
  background: var(--p-green-50);
  color: var(--p-green-700);
  font-size: 0.8rem;
}

.badge.inactive {
  background: var(--tj-primary-gray-50);
  color: var(--tj-primary-gray-600);
}

.error {
  color: var(--p-red-700);
  background: var(--p-red-50);
  padding: 0.75rem;
  border-radius: 0.4rem;
}

.notice {
  color: var(--p-green-700);
}

.empty {
  padding: 2rem;
  text-align: center;
  color: var(--tj-primary-gray-500);
}

.editor {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.editor small {
  color: var(--tj-primary-gray-500);
}

.editor-actions {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.5rem;
}

@media (max-width: 640px) {
  .booking-status-page {
    padding: 1rem;
  }
  .heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .toolbar label {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/admin/booking-status/booking-status.component.scss"],"names":[],"mappings":"AAAA;EAAQ,cAAA;AAER;;AADA;EAAuB,WAAA;EAAa,iBAAA;EAAmB,YAAA;EAAc,yBAAA;AAQrE;;AAPA;EAAW,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,qBAAA;AAe1F;AAfiH;EAAK,iBAAA;EAAmB,kBAAA;AAmBzI;AAnB8J;EAAI,SAAA;EAAW,iCAAA;AAuB7K;;AAtBA;EAAiB,qCAAA;EAAuC,oBAAA;EAAqB,qBAAA;AA4B7E;AA5BmG;EAAI,oBAAA;AA+BvG;;AA9BA;EAAS,8BAAA;EAAgC,4CAAA;EAA8C,qBAAA;EAAsB,gBAAA;AAqC7G;;AApCA;EAAW,aAAA;EAAe,qBAAA;EAAuB,eAAA;EAAiB,SAAA;EAAW,aAAA;AA4C7E;AA5C4F;EAAO,iBAAA;EAAmB,iCAAA;AAgDtH;;AA/CA;EAAQ,aAAA;EAAe,sBAAA;EAAwB,WAAA;EAAY,iBAAA;EAAkB,gBAAA;AAuD7E;;AAtDA;EAAmB,4CAAA;EAA8C,qBAAA;EAAsB,cAAA;EAAgB,8BAAA;EAAgC,gBAAA;EAAiB,aAAA;AA+DxJ;;AA9DA;EAAS,mBAAA;EAAqB,mBAAA;EAAqB,gBAAA;EAAkB,kBAAA;AAqErE;;AApEA;EAAc,kBAAA;EAAmB,gBAAA;EAAkB,iCAAA;EAAmC,kBAAA;EAAmB,mBAAA;AA4EzG;;AA3EA;EAAgB,iBAAA;AA+EhB;AA/EkC;EAAO,cAAA;EAAgB,mBAAA;EAAqB,qBAAA;AAoF9E;;AAnFW;EAAS,oBAAA;EAAqB,qBAAA;AAwFzC;;AAvFA;EAAqD,SAAA;EAAW,eAAA;EAAgB,qBAAA;EAAsB,uBAAA;EAAyB,4BAAA;EAA8B,aAAA;EAAe,eAAA;AAiG5K;;AAjG+L;EAAmB,uBAAA;AAqGlN;;AApGA;EAAS,sBAAA;EAAsB,qBAAA;EAAsB,6BAAA;EAA+B,yBAAA;EAA2B,iBAAA;AA4G/G;;AA5GmI;EAAkB,qCAAA;EAAuC,iCAAA;AAiH5L;;AAhHA;EAAS,uBAAA;EAAyB,2BAAA;EAA6B,gBAAA;EAAiB,qBAAA;AAuHhF;;AAvHwG;EAAU,yBAAA;AA2HlH;;AA3H+I;EAAS,aAAA;EAAe,kBAAA;EAAoB,iCAAA;AAiI3L;;AAhIA;EAAU,aAAA;EAAe,sBAAA;EAAwB,YAAA;AAsIjD;AAtI8D;EAAQ,iCAAA;AAyItE;;AAzI6G;EAAkB,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,kBAAA;AAgJzL;;AA/IA;EAA4B;IAAuB,aAAA;EAoJjD;EApJkE;IAAW,uBAAA;IAAyB,sBAAA;EAwJtG;EAxJgI;IAAiB,WAAA;EA2JjJ;AACF;AACA,o2KAAo2K","sourcesContent":[":host { display: block; }\n.booking-status-page { width: 100%; max-width: 1680px; margin: auto; padding: 1.5rem 2rem 3rem; }\n.heading { display: flex; justify-content: space-between; align-items: center; gap: 1rem; margin: 1.5rem 0 1rem; h1 { font-size: 1.5rem; margin: 0 0 .4rem; } p { margin: 0; color: var(--tj-primary-gray-500); } }\n.schedule-note { background: var(--tj-primary-gray-50); padding: .9rem 1rem; border-radius: .5rem; i { margin-right: .5rem; } }\n.panel { background: var(--p-surface-0); border: 1px solid var(--tj-primary-gray-200); border-radius: .6rem; overflow: hidden; }\n.toolbar { display: flex; align-items: flex-end; flex-wrap: wrap; gap: 1rem; padding: 1rem; span { margin-left: auto; color: var(--tj-primary-gray-500); } }\nlabel { display: flex; flex-direction: column; gap: .4rem; font-size: .9rem; font-weight: 600; }\nselect, textarea { border: 1px solid var(--tj-primary-gray-300); border-radius: .4rem; color: inherit; background: var(--p-surface-0); padding: .65rem; font: inherit; }\n.check { flex-direction: row; align-items: center; font-weight: 400; min-height: 2.5rem; }\n.definition { margin: .4rem 0 0; max-width: 32rem; color: var(--tj-primary-gray-500); font-size: .85rem; white-space: normal; }\n.observations { font-size: .8rem; span { display: block; white-space: nowrap; margin-bottom: .3rem; } }\n.actions { button { margin-right: .6rem; margin-bottom: .4rem; } }\nbutton.text-button, .actions button, .error button { border: 0; padding: .5rem; border-radius: .3rem; background: transparent; color: var(--tj-primary-600); font: inherit; cursor: pointer; } .actions .delete { color: var(--p-red-700); }\n.badge { padding: .3rem .5rem; border-radius: .3rem; background: var(--p-green-50); color: var(--p-green-700); font-size: .8rem; } .badge.inactive { background: var(--tj-primary-gray-50); color: var(--tj-primary-gray-600); }\n.error { color: var(--p-red-700); background: var(--p-red-50); padding: .75rem; border-radius: .4rem; } .notice { color: var(--p-green-700); } .empty { padding: 2rem; text-align: center; color: var(--tj-primary-gray-500); }\n.editor { display: flex; flex-direction: column; gap: .75rem; small { color: var(--tj-primary-gray-500); } } .editor-actions { display: flex; justify-content: space-between; gap: 1rem; margin-top: .5rem; }\n@media (max-width: 640px) { .booking-status-page { padding: 1rem; } .heading { align-items: flex-start; flex-direction: column; } .toolbar label { width: 100%; } }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
